export default {
   appendIfDefined: function (url, urlParam, urlParamValue) {
      if(urlParamValue) {
         return url + '&' + urlParam + "=" + urlParamValue;
      }
      return url;
   }
}